import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CopyClipboardButton from '@src/components/AdminHome/Common/CopyClipboardButton';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export interface ReadOnlyContactFieldsProps {
  bsuid?: string;
  whatsappUsername?: string;
}

const ReadOnlyContactFields: FC<ReadOnlyContactFieldsProps> = ({
  bsuid,
  whatsappUsername,
}) => {
  const classes = useStyles();

  if (!bsuid && !whatsappUsername) return null;

  return (
    <Box className={classes.container}>
      {bsuid && (
        <Box className={classes.fieldRow}>
          <Box className={classes.fieldContent}>
            <Typography className={classes.label}>
              <FormattedMessage id="ContactForm.bsuid" />
            </Typography>
            <Typography className={classes.value}>{bsuid}</Typography>
          </Box>
          <CopyClipboardButton
            textoToClipboard={bsuid}
            aria-label="Copy BSUID"
            className={classes.copyButton}
          />
        </Box>
      )}
      {whatsappUsername && (
        <Box className={classes.fieldRow}>
          <Box className={classes.fieldContent}>
            <Typography className={classes.label}>
              <FormattedMessage id="ContactForm.whatsappUsername" />
            </Typography>
            <Typography className={classes.value}>
              {whatsappUsername}
            </Typography>
          </Box>
          <CopyClipboardButton
            textoToClipboard={whatsappUsername}
            aria-label="Copy WhatsApp Username"
            className={classes.copyButton}
          />
        </Box>
      )}
    </Box>
  );
};

export default ReadOnlyContactFields;

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor:
      theme.palette.type === 'dark' ? 'rgba(110, 96, 228, 0.15)' : '#F0EEFF',
    borderRadius: 8,
    padding: '10px 14px',
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  fieldContent: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    flex: 1,
  },
  label: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    lineHeight: 1.1,
  },
  value: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontFamily: 'Poppins, sans-serif',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  copyButton: {
    flexShrink: 0,
    marginLeft: 4,
    padding: 6,
  },
}));
